import { useState, createContext } from "react";
import es from "../../translations/es.json";
import en from "../../translations/en.json";

/** Constante del contexto de internacionalizacion */
export const LocaleContext = createContext({});

export const LocaleProvider = (props) => {

  const [locale, setSelectedLocale] = useState(localStorage.getItem("Locale") || "es-MX");
  const resources = { es, en };

  const getLanguage = (str) => {
    return String(str || "").substring(0,2);
  }

  const handleChangeLocale = (value) => {
    localStorage.setItem("Locale", value);
    setSelectedLocale(value);
  }

  return (
    <LocaleContext.Provider 
      value={{
        activeResource: resources[ getLanguage(locale) ],
        locale: locale,
        changeLocale: handleChangeLocale, 
      }}
    >
      {props.children}
    </LocaleContext.Provider>
  );
};